import React, { useEffect, useState, useCallback } from "react";
import { RefreshCw } from "lucide-react";
import { http } from "@/lib/api";

/** Simple arithmetic captcha (e.g. "5 + 3 = ?"). Calls onChange({captcha_id, answer}). */
export default function Captcha({ onChange }) {
  const [c, setC] = useState(null);
  const [answer, setAnswer] = useState("");

  const load = useCallback(() => {
    http.get("/auth/captcha").then((r) => {
      setC(r.data);
      setAnswer("");
      onChange({ captcha_id: r.data.captcha_id, answer: "" });
    }).catch(() => {});
  }, [onChange]);

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const upd = (v) => { setAnswer(v); onChange({ captcha_id: c?.captcha_id, answer: v }); };

  return (
    <div data-testid="captcha-widget">
      <label className="text-[11px] uppercase tracking-[0.14em] text-[#8A8175] font-bold">Security check</label>
      <div className="flex items-center gap-2 mt-1.5">
        <div className="flex items-center gap-1.5 bg-[#FFF5EB] border border-[#F0DAC2] rounded-lg px-3 py-3 select-none" data-testid="captcha-question">
          <span className="font-mono font-bold text-[#A5300F] text-sm whitespace-nowrap">{c ? c.question : "…"} =</span>
        </div>
        <input data-testid="captcha-answer" inputMode="numeric" value={answer} onChange={(e) => upd(e.target.value)} placeholder="?"
          className="w-20 bg-[#FDFBF8] border border-[#E7D9C6] rounded-lg px-3 py-3 text-sm text-center focus:outline-none focus:border-[#A5300F] focus:bg-white" />
        <button type="button" onClick={load} data-testid="captcha-refresh" title="New question"
          className="p-3 text-[#B5AC9E] hover:text-[#A5300F] border border-[#E7D9C6] rounded-lg"><RefreshCw className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
